import React from 'react';
import HTMLComment from 'react-html-comment';

const PromotionBarComponent = (props) => {

    return(
        <div className="PromotionBar d-block">
            <div className="container-lg">
                <HTMLComment text="googleoff: all" />
                *** NEWLY LAUNCHED: We are now offering Experiences for you to book ***
                <HTMLComment text="googleon: all" />
            </div>
        </div>
    );

}

export default React.memo(PromotionBarComponent);